import { useState } from "react"

export const DropdownComponent = ({name, inititalValue, onChange, options, isValid, required,questionKey})=>{
    const [value, setValue] = useState(inititalValue)
    const onDropdownChange = (e) =>{
        setValue(e.target.value);
        onChange(e.target.name, e.target.value,questionKey, required)
    }
    return(
        <div className="form-field">
           <select className={`dd-field ${required && !isValid ?'invalid-input':''}`} name={name} onChange={onDropdownChange} value={value}>
            <option value="">Select</option>
            {
                options.map((option) =>{
                    return <option key={option} value={option}>{option} </option>
                })
            }
           </select>
           {required && !isValid && <p className="validation-error">Field is required</p> }
        </div>
    )
}